import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { S3_URL, CODE_SYSTEM } from "../services/Constants";
import {
  fetchCodeSetListTable,
  fetchCodeSetTable,
  updateCodeSetTable,
} from "../services/referenceTable-service";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { CSNANVB, CSNDB } from "../util/component-codes";

const initialRows = [
  {
    reference_table_id: null,
    reference_code: "",
    reference_Code_description: "",
    reference_Code_system: "",
  },
];
const CodeSetNormalization = () => {
  const [dropdownValues, setDropdownValues] = useState(null);
  const [valueSet, setValueSet] = useState("");
  const [rows, setRows] = useState(JSON.parse(JSON.stringify(initialRows)));
  const [tableId, setTableId] = useState(0);
  const [user] = useContext(UserContext);

  const addUpdateValueSet = () => {
    let copy = [...rows];
    let newArray = { ...initialRows[0] };
    copy.push(newArray);
    setRows(copy);
  };

  const updateReferenceTableValuesRows = (copyRows) => {
    let form = {
      referenceTableId: tableId,
      referenceTableName: valueSet,
      refTableValues: copyRows,
    };
    updateCodeSetTable(tableId, form);
  };

  const removeRow = (index) => {
    let copyRows = [...rows];
    copyRows.splice(index, 1);
    setRows(copyRows);
    updateReferenceTableValuesRows(copyRows);
  };

  const addOrUpdateValueSet = (index, key, value) => {
    let copyRows = [...rows];
    let X = copyRows[index];
    X[key] = value;
    setRows(copyRows);
    updateReferenceTableValuesRows(copyRows);
  };

  const updateRows = (index, value) => {
    let copyRows = [...rows];
    let X = copyRows[index];
    X["reference_code"] = value;
    X["reference_Code_description"] = value;
    setRows(copyRows);
    
    if(X["reference_Code_system"]!==""){
      updateReferenceTableValuesRows(copyRows);
    }
  };

  const handleValueSetChange = async (value) => {
    setValueSet(value);

    let response = await fetchCodeSetTable(value);
    if (response.ok) {
      let data = await response.json();
      setRows(data.refTableValues ? data.refTableValues : null);
      setTableId(data.referenceTableId ? data.referenceTableId : 0);
    }
  };

  const getCodeSetListTableData = async () => {
    let response = await fetchCodeSetListTable();
    let data = await response.json();
    let array = [];
    data.refTableValues.forEach(function (item, index) {
      array.push(item.reference_code);
    });
    setDropdownValues(array);
  };

  useEffect(() => {
    dropdownValues === null && getCodeSetListTableData();
    dropdownValues !== null && handleValueSetChange("Normalize Code Set");
  }, [dropdownValues]);

  return (
    <Container fluid className="loincContainer">
      <Row>
        <Col xl={8}>
          <Row className="tableTitle generalFont">Code Set Normalization</Row>
        </Col>
      </Row>
      <br />
      <br />
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="sendingFacilityName">
            <Form.Label className="modalLabel generalFont">
              Value Set
            </Form.Label>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="sendingFacilityCode">
            <Form.Label className="modalLabel generalFont">
              Code System
            </Form.Label>
          </Form.Group>
        </Col>
        <Col xs={1}></Col>
        <Col></Col>
        <Col></Col>
        <Col></Col>
      </Row>
      {rows &&
        rows.map((row, index) => {
          return (
            <>
              <Row>
                <Col>
                  <Form.Select
                    className="modalInput generalFont"
                    type="text"
                    required
                    value={row.reference_code}
                    onChange={(e) => {
                      updateRows(index, e.target.value);
                    }}
                  >
                    {" "}
                    <option hidden value="">
                      Choose Item
                    </option>
                    {dropdownValues &&
                      dropdownValues
                        .filter(
                          (item) =>
                            !rows.some((row) => row.reference_code === item)
                        )
                        .map((value) => {
                          return (
                            <option key={value} value={value}>
                              {value}
                            </option>
                          );
                        })}
                    {row.reference_code !== "" && (
                      <option
                        key={row.reference_code}
                        value={row.reference_code}
                      >
                        {row.reference_code}
                      </option>
                    )}
                  </Form.Select>
                </Col>

                <Col>
                  {" "}
                  <Form.Select
                    name="sourceField"
                    className="modalInput generalFont"
                    aria-label="Field"
                    required
                    disabled={row.reference_code === ""}
                    value={row.reference_Code_system}
                    onChange={(e) =>
                      addOrUpdateValueSet(
                        index,
                        "reference_Code_system",
                        e.target.value
                      )
                    }
                  >
                    <option hidden value="">
                      Choose Item
                    </option>
                    {CODE_SYSTEM.map((value, index) => (
                      <option key={index} value={value}>
                        {value}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs={1}>
                  {componentIsVisible(CSNDB, user) && (
                    <Button
                      onClick={(event) => removeRow(index)}
                      className="removeButtonStylegreybackground generalFont flexCenter "
                    >
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
                        className="buttonIcon"
                        alt=""
                      ></img>
                    </Button>
                  )}
                </Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <br />
            </>
          );
        })}
      {componentIsVisible(CSNANVB, user) && (
        <Button
          className="modalAddUpdateStyle generalFont flexCenter"
          onClick={() => addUpdateValueSet()}
        >
          Add New Value
        </Button>
      )}
    </Container>
  );
};

export default CodeSetNormalization;
